import { render } from "./NewSubAgent.vue?vue&type=template&id=c1728d7e"
import script from "./NewSubAgent.vue?vue&type=script&lang=js"
export * from "./NewSubAgent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__